/*
 * Ryan O'Dowd
 * 2024-03-03
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useEffect,
  useState,
} from 'react';
import Accordion from '@components/common/Accordion';
import Assignment from './Assignment';
import DraggableFlatList from 'react-native-draggable-flatlist';
import EditAssignmentDialog from '../EditAssignmentDialog';
import EditModuleDialog from '../EditModuleDialog';
import Icon from '@react-native-vector-icons/material-design-icons';
import IconButton from '@components/common/IconButton';
// @TODO: import PublishedStatus from '../PublishedStatus';
import Tooltip from '@components/common/Tooltip';
import {
  TouchableOpacity,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';
import {
  updateModule,
} from '@utils/store/actions';
import utilities from '@utils/utilities';

const Module = (props: ModuleProps) => {
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();

  const [_isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [_isNewAssignmentDialogOpen, setIsNewAssignmentDialogOpen] = useState(false);
  const [_expanded, setExpanded] = useState(false);

  const [_assignmentOrderOverrides, setAssignmentOrderOverrides] = useState(props.module.assignments);

  useEffect(() => {
    setAssignmentOrderOverrides(props.module.assignments);
  }, [props.module.assignments]);

  return (
    <Accordion
      onChange={(expanded) => setExpanded(expanded)}
      leftItem={
        <TouchableOpacity
          style={styles.dragIconWrapper}
          onPressIn={props.drag}
          delayLongPress={0}
        >
          <Icon
            name='drag'
            size={30}
            color={styles.colors.primaryExtraLight}
          />
        </TouchableOpacity>
      }
      title={// @TODO: replace with title, subtitle, and leftItem
        <span style={styles.editRow}>
          <span style={styles.fullTitleWrapper}>
            <h2 style={styles.moduleName}>{props.module.name}</h2>{/* @TODO: <Editable textValue={module.name} label='Module name' id={module.id} model='module' field='name' title='Edit module name' />{/* @TODO: onedit, don't toggle accordion */}{/* @TODO: maybe don't need this...make custom dialogs for new/edit module and new/edit assignment */}
            <span style={styles.subTitle}>{utilities.prettyAvailablityDateRange(props.module.date_available, props.module.date_deadline)}</span>
          </span>
          <span style={styles.actionsWrapper}>
            {_expanded &&
              <Tooltip title='Edit module'>
                <IconButton
                  icon='pencil'
                  iconColor={styles.colors.white}
                  onPress={() => setIsEditDialogOpen(true)}
                />
              </Tooltip>
            }
            {/* @TODO: only goals have draft/published status right now
            <PublishedStatus status={props.module.status} module={props.module} />
            */}
          </span>
        </span>
      }
    >
      <DraggableFlatList
        keyExtractor={(assignment: any) => assignment.id}
        // @TODO: style={styles.list}
        data={_assignmentOrderOverrides}
        renderItem={(d) => {
          const assignment = d.item;

          return (
            <Assignment
              key={assignment.id}
              goal={props.goal}
              module={props.module}
              assignment={assignment}
              drag={d.drag}
            />
          );
        }}
        showsVerticalScrollIndicator={false}
        activationDistance={1}// @NOTE: needs to be here for web to work
        keyboardDismissMode='on-drag'
        keyboardShouldPersistTaps='handled'
        scrollEnabled={true}
        onDragEnd={({data}) => {
          // @NOTE: temporarily (component state) set note order so that the delay caused by writing to firebase, updating redux, and rerendering doesn't cause a flicker where the dragged note goes back to its original place and then jumps to the new location // @TODO: leftover comment from tibbits
          setAssignmentOrderOverrides(data);
          dispatch(updateModule(props.goal.classroom_goal_metadata.classroom_id, props.goal.id, props.module.id, undefined, undefined, undefined, undefined, data.map((a) => a.id)));
        }}
      />
      <Accordion
        onChange={() => setIsNewAssignmentDialogOpen(true)}
        expandable={false}
        title='+ Add new assignment'
        theme='white'
      >
        {null}
      </Accordion>
      {_isNewAssignmentDialogOpen && <EditAssignmentDialog goal={props.goal} module={props.module} isNew={true} onClose={() => setIsNewAssignmentDialogOpen(false)} />}
      {_isEditDialogOpen && <EditModuleDialog goal={props.goal} module={props.module} onClose={() => setIsEditDialogOpen(null)} />}
    </Accordion>
  );
};

class ModuleProps {
  goal: any;
  module: any;
  drag: any;
};

export default Module;
